// extracted by mini-css-extract-plugin
module.exports = {"root":"TwoColumnsGrid_root__Tne2e"};